import script from "./MHModal.vue?vue&type=script&setup=true&lang=js"
export * from "./MHModal.vue?vue&type=script&setup=true&lang=js"

import "./MHModal.vue?vue&type=style&index=0&id=411a9760&lang=scss"

const __exports__ = script;

export default __exports__